define("shared/helpers/-private/intl/t", ["exports", "@ember/application", "ember-intl/helpers/t"], function (_exports, _application, _t) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/application",0,"ember-classic-decorator",0,"ember-intl/helpers/t"eaimeta@70e063a35619d71f

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  class T extends _t.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "allowEmpty", true);
    }

    format(key, options) {
      try {
        return this.intl.t(key, options);
      } catch (error) {
        const errors = (0, _application.getOwner)(this).lookup('service:errors');

        if (errors) {
          errors.log(error, {
            key,
            options
          }, 'critical');
        }
      }
    }

  }

  _exports.default = T;
});